import { createSlice } from '@reduxjs/toolkit';
import auth from '../utils/auth';
import { default as jwt } from 'jsonwebtoken';

let token = auth.getToken();
let user = auth.getToken() ? jwt.decode(token) : {};

let initialState = {
    is_authenticated: !!token || auth.loggedIn(),
    ...user?.customer
};

export const sessionSlice = createSlice({
    name: 'session',
    initialState,
    reducers: {
        sessionSuccess: (state, action) => {
            return {
                ...state,
                is_authenticated: true,
                ...action.payload
            };
        },
        sessionDestroy: () => {
            return { is_authenticated: false };
        }
    }
});

export const { sessionDestroy, sessionSuccess } = sessionSlice.actions;

export default sessionSlice.reducer;
